import React, { CSSProperties, FC, ReactNode, useEffect } from 'react';
import GeneralModalClosingBtn from './GeneralModalClosingBtn';
import Modal from './Modal';
import style from '../../../styles/components/modal.module.css';
import { ModalSizeType } from '../../../types/modal.type';
import { useGetLangDirectionApp } from '../../../stores/app.store';

type Props = {
    show: boolean,
    title: string,
    closingFunc: () => void,
    body: string | ReactNode,
    footer?: string | ReactNode,
    modalSize?: ModalSizeType,
    loading?: boolean,
    alertUser?: ReactNode,
}

const GeneralModal: FC<Props> = ({
    show,
    title,
    closingFunc,
    body,
    footer = '',
    modalSize = 'S',
    loading = false,
    alertUser = null
}) => {

    const langDirection = useGetLangDirectionApp();

    const isRtl = langDirection === 'rtl';

    const flexHeaderInnerDir = isRtl ? 'row' : 'row-reverse';
    const bodyStyle: CSSProperties = {
        opacity: loading ? 0.6 : 1,
        overflow: 'auto',
        maxHeight: '56vh',
        position: 'relative',
        direction: isRtl ? 'ltr' : 'rtl'
    };

    const innerBodyStyle: CSSProperties = {
        padding: '0.5rem',
        minHeight: '7rem',
        fontSize: '1.2rem',
        width: '100%',
        direction: isRtl ? 'rtl' : 'ltr'
    };

    useEffect(() => {
        handleIsOpenChange(show);
        return () => {
            document.body.style.overflow = "";
        };
    }, [show]);

    if (!show) return null;

    return (
        <Modal modalSize={modalSize}>

            {/* Header Section */}
            <div className={style.header}>
                <div style={{
                    padding: '0.5rem',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    flexDirection: flexHeaderInnerDir,
                    width: '100%'
                }}>
                    {isRtl ? <div className="fs-4">{title}</div> : null}
                    <GeneralModalClosingBtn onClick={closingFunc} />
                    {!isRtl ? <div className="fs-4">{title}</div> : null}
                </div>
                {loading && <div className={style.loader} />}
            </div>

            {/* Body Section */}
            <div style={bodyStyle}>

                <div style={innerBodyStyle}>

                    {/* Alert User Section */}
                    {alertUser && (
                        <div style={{ position: 'fixed', top: '2.5rem', left: 0, right: 0, padding: '0.5rem', zIndex: 1000 }}>
                            {alertUser}
                        </div>
                    )}

                    {/* Body Content Section */}
                    {body}
                </div>
            </div>

            {/* Footer Section */}
            {(footer && footer !== null) && (
                <>
                    <div className={style.hr} />
                    <div className={style.footer}> {footer} </div>
                </>
            )}

        </Modal>
    );

    /**
     * Handle disable or enable scrolling when clicking outside the modal content.
     * @param isOpen - Indicates whether the modal is open or closed.
     */
    function handleIsOpenChange(isOpen: boolean) {
        document.body.style.overflow = isOpen ? "hidden" : "";
    }

}


export default GeneralModal;